import { isPeselSkipCode } from '@/components/slides/PeselCheck/usePeselCheck.ts';
import { isZaIdSkipCode } from '@/util/useZaIdValidator.ts';

interface BirthdateFlowArgs {
  peselCheckResult?: string;
  pesel?: string;
  zaId?: string;
  birthdate?: string;
}

const hasBirthdateValue = (birthdate?: string): boolean => {
  return Boolean(birthdate?.trim());
};

export function shouldUseBirthdateManualFlow({ peselCheckResult, pesel, zaId, birthdate }: BirthdateFlowArgs): boolean {
  const hasZaIdValue = Boolean(zaId?.trim());

  return (
    peselCheckResult === 'skipped' ||
    peselCheckResult === 'poltransplant-offline' ||
    (peselCheckResult === 'not-registered' && !hasBirthdateValue(birthdate)) ||
    (hasZaIdValue && !hasBirthdateValue(birthdate)) ||
    isPeselSkipCode(pesel ?? '') ||
    isZaIdSkipCode(zaId ?? '')
  );
}

